import React, { useContext, useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { LabelText } from '../../../components/Language';
import { OverviewContext } from '../../context/OverviewProvider';
import OverviewDetailFooter from '../../../NmbsUser/components/OverviewDetailFooter/OverviewDetailFooter'
import filterFactory, { customFilter } from 'react-bootstrap-table2-filter';
import FilterOverlayTrigger from '../../../components/UI/Filter/FilterOverlayTrigger';
import Sort from '../../../components/UI/Sort/Sort';
import { NotificationCount } from './NotificationCount';
import { sortDate } from '../../../common/utility/utility';
import { changeRequestTooltip } from '../../../components/UI/Tooltip/Tooltip';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import '../../../components/UI/Sort/Sort.css';
import '../index.css';

export default function UnsubmittedOverviewDetails() {
    const { overviewDetails, handlerOnClearFilterClick, isClearFilter,
        handlerCheckDetailsFilterApplied } = useContext(OverviewContext);
    const [filterData, setFilterData] = useState([]);
    const [columnFilterIndexes, setColumnFilterIndexes] = useState([]);
    const [columnFilterOptions, setColumnFilterOptions] = useState(new Map());
    let data = overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos &&
        overviewDetails.nmbsUserDetailOverviewDtos.length > 0 ? overviewDetails.nmbsUserDetailOverviewDtos : [];

    const handlerFilterOverlayTrigger = (column, colName, isDate, isNested,
        nestedObjectField, isTotalColumn, isRuleValue) => {
        return (<FilterOverlayTrigger column={column}
            colName={colName}
            data={data}
            filterData={filterData}
            columnFilterIndexes={columnFilterIndexes}
            columnFilterOptions={columnFilterOptions}
            isDate={isDate}
            isNested={isNested}
            nestedObjectField={nestedObjectField}
            isTotalColumn={isTotalColumn}
            setColumnFilterOptions={setColumnFilterOptions}
            setFilterData={setFilterData}
            isRuleValue={isRuleValue}
            setColumnFilterIndexes={setColumnFilterIndexes}
            handlerCheckDetailsFilterApplied={handlerCheckDetailsFilterApplied}
        />);
    }

    useEffect(() => {
        if (isClearFilter) {
            setFilterData([]);
            setColumnFilterIndexes([]);
            setColumnFilterOptions(new Map());
            handlerOnClearFilterClick(false);
        }
    }, [isClearFilter]);

    useEffect(() => {
        let header = document.querySelectorAll(".OverviewDetails-datatable thead th");
        if (header && header.length > 0) {
            header.forEach(element => {
                element.setAttribute("tabindex", "-1");
            });
        }
    }, []);

    const sortHandler = (order, column) => {
        return (<Sort order={order} />)
    }

    const notificationCountFormatter = (row, columnIndex) => {
        return (
            <NotificationCount row={row} columnIndex={columnIndex} />
        )
    }

    const getFormattedRuleData = (row, fieldName) => {
        return (
            <div>
                {
                    fieldName == 'billingRule' ?
                        <span><LabelText tid={row.billingRule} /></span>
                        : <span><LabelText tid={row.conditionRule} /></span>
                }
            </div>
        )
    }

    const contractCodeFormatter = (row) => {
        return (<div>
            {row.changeRequest !== null ? (row.changeRequest.isUnblockPending ? <div style={{ float: "right", marginTop: "0.7vw" }}>
                <CustomOverlayTrigger placement="right" tooltip={changeRequestTooltip("cr_pending", row.changeRequest && row.changeRequest.unblockCrNumber)}>
                    <div style={{ float: "right" }} className="fa-cr-unblock" />
                </CustomOverlayTrigger>
                {row.contractCode}
            </div>
                : <div style={{ display: "flex", float: "right", marginRight: "2.5vw" }}>{row.contractCode}</div>)
                : <div style={{ display: "flex", float: "right", marginRight: "2.5vw" }}>{row.contractCode}</div>
            }
        </div>
        )
    }

    const reveneDateFormatter = (row) => {
        return (
            <div>
            {row.changeRequest !== null ? (row.changeRequest.isUnblockPending ? <div style={{ float: "right", marginTop: "0.7vw" }}>
                <CustomOverlayTrigger placement="right" tooltip={changeRequestTooltip("cr_pending", row.changeRequest && row.changeRequest.unblockCrNumber)}>
                    <div style={{ float: "right" }} className="fa-cr-unblock" />
                </CustomOverlayTrigger>
                {row.revenueDate}
            </div>
                : <div style={{ display: "flex", float: "right", marginRight: "2.5vw" }}>{row.revenueDate}</div>)
                : <div style={{ display: "flex", float: "right", marginRight: "2.5vw" }}>{row.revenueDate}</div>
            }
        </div>
        )
    }


    const columns = [
        {
            dataField: 'businessPartnerName',
            text: <span class="column-header-text"><LabelText tid="businesspartner_payername" /></span>,
            styles: "businessPartnerName",
            columnIndex: 0,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "businessPartnerName", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'concessionName',
            text: <span class="column-header-text"><LabelText tid="concessionname" /></span>,
            editable: false,
            columnIndex: 1,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "concessionName", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'stationName',
            text: <span class="column-header-text"><LabelText tid="station" /></span>,
            editable: false,
            columnIndex: 2,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "stationName", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'contractCode',
            text: <span class="column-header-text"><LabelText tid="contractcode" /></span>,
            editable: false,
            columnIndex: 3,
            filter: customFilter(),
            formatter: (cell, row, rowIndex) => contractCodeFormatter(row),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractCode", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'contractStatus',
            text: <span class="column-header-text"><LabelText tid="contractstatus" /></span>,
            editable: false,
            columnIndex: 4,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractStatus", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'notificationCount',
            text: <span class="column-header-text"><LabelText tid="notification-counter" /></span>,
            editable: false,
            columnIndex: 5,
            formatter: (cell, row, rowIndex) => notificationCountFormatter(row, 4),
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "notificationCount", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column),
            sortFunc: (a, b, order) => {
                if (order === 'desc') {
                    return Number(b) - Number(a);
                }

                return Number(a) - Number(b) // desc
            }
        },
        {
            dataField: 'revenueDate',
            text: <span class="column-header-text"><LabelText tid="Day" /></span>,
            editable: false,
            columnIndex: 6,
            filter: customFilter(),
            formatter: (cell, row, rowIndex) => reveneDateFormatter(row),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "revenueDate", true, true, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column),
            sortFunc: sortDate
        },
        {
            dataField: 'onboardingDate',
            text: <span class="column-header-text"><LabelText tid="onboardingdate" /></span>,
            editable: false,
            columnIndex: 7,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "onboardingDate", true, true, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column),
            sortFunc: sortDate
        },
        {
            dataField: 'businessPartnerCode',
            text: <span class="column-header-text"><LabelText tid="businesspartnercode" /></span>,
            editable: false,
            columnIndex: 8,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "businessPartnerCode", false, false, null, false, false),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'billingRule',
            text: <span class="column-header-text"><LabelText tid="billing_rule" /></span>,
            editable: false,
            columnIndex: 9,
            filter: customFilter(),
            formatter: (cell, row, rowIndex) => getFormattedRuleData(row, "billingRule"),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "billingRule", false, false, null, false, true),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        },
        {
            dataField: 'conditionRule',
            text: <span class="column-header-text"><LabelText tid="condition_rule" /></span>,
            editable: false,
            columnIndex: 10,
            filter: customFilter(),
            formatter: (cell, row, rowIndex) => getFormattedRuleData(row, "conditionRule"),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "conditionRule", false, false, null, false, true),
            sort: true,
            sortCaret: (order, column) => sortHandler(order, column)
        }
    ];

    const tableRowStyle = (row, rowIndex) => {
        row.index = rowIndex;
        const style = {};
        style.lineHeight = "7vh";
        if (row.isContractStatusInActive) {
            style.backgroundColor = '#cccccc';
        } else {
            if (rowIndex % 2 === 0)
                style.backgroundColor = '#ffffff';
            else
                style.backgroundColor = '#eff4f9';
        }

        return style;
    }


    return (
        <div className="OverviewDetails-main">
            <Container>
                <Row>
                    <BootstrapTable
                        keyField='nmbsUserDetailOverviewDtos.contractId'
                        data={filterData && filterData.length > 0 ? filterData : data}
                        columns={columns}
                        filter={filterFactory()}
                        bordered
                        rowStyle={tableRowStyle}
                        classes={"OverviewDetails-datatable scroller"}
                        headerClasses={"OverviewDetails-datatable-header"}
                    //noDataIndication={<LabelText tid="Noactivecontract" />}
                    />
                </Row>
                {
                    <Row><div style={{ width: '100%' }}>
                        <OverviewDetailFooter />
                    </div>
                    </Row>
                }
            </Container> </div>
    );

}